import { useEffect, useState, useRef } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import ExportButtons from '../ExportButtons';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const Dird = (props) => {
    const [items, setItems] = useState({ reports: {} });

    // Refs para tabelas
    const demonstrativesRevenueRef = useRef(null);
    const sourceReceiptRevenueRef = useRef(null);
    const dirdExpenseRef = useRef(null);
    const resumeRef = useRef(null);
    const conciliationRef = useRef(null);
    const financialBalanceRef = useRef(null);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Fetch.post(
                    `${config.endpoints.backend}portal/getreport`,
                    props.filters
                );
                setItems(response);
            } catch (error) {
                console.error('Erro ao buscar relatório DIRD completo:', error);
            }
        };

        fetchData();
    }, [JSON.stringify(props.filters)]);

    const dirdReport = items?.reports?.dirdReport;
    const revenueReport = items?.reports?.revenueReport;
    const fisicalBalance = items?.reports?.fisicalBalance;

    const projectName = items?.reports?.pdcProject?.project_name || '';
    const originResourceName = items?.reports?.originResourceName || '';

    // =================== EXPORTAÇÃO DIRD ===================
    function dataForSheetDird() {
        const table = document.getElementById('table_dird_expense');
        const resumeTable = document.getElementById('resume_dird_expense');
        const conciliationTable = document.getElementById('conciliation_dird_expense');

        if (!table || !resumeTable || !conciliationTable) {
            console.error('Uma ou mais tabelas do DIRD não foram encontradas.');
            return { dataTable: [], resumeData: [], conciliationData: [] };
        }

        const dataTable = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table, { raw: true }), { header: 1, raw: true });
        const resumeData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(resumeTable, { raw: true }), { header: 1, raw: true });
        const conciliationData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(conciliationTable, { raw: true }), { header: 1, raw: true });

        return { dataTable, resumeData, conciliationData };
    }

    function dataForCsvDird() {
        const table = document.getElementById('table_dird_expense');
        const resumeTable = document.getElementById('resume_dird_expense');
        const conciliationTable = document.getElementById('conciliation_dird_expense');

        if (!table || !resumeTable || !conciliationTable) {
            console.error('Uma ou mais tabelas do DIRD não foram encontradas.');
            return [];
        }

        const dataTable = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table, { raw: true }), { header: 1, raw: true });
        const resumeData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(resumeTable, { raw: true }), { header: 1, raw: true });
        const conciliationData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(conciliationTable, { raw: true }), { header: 1, raw: true });

        let combinedData = [];
        combinedData = combinedData.concat(dataTable, [], resumeData, [], conciliationData);

        return combinedData;
    }

    function dataForJsonDird() {
        if (!items?.reports) return {};
        let principalReport = {};
        let dirdConciliationReport = {};
        let othersValues = {};

        const headers = [...(items.reports.headers || [])];
        headers.shift();
        const rows = items.reports.rows || [];

        headers.forEach((header) => {
            principalReport[header] = {};
            rows.forEach((row) => {
                principalReport[header][row] = items.reports[header]?.[row] ?? null;
            });
        });

        (items.reports.dirdConciliation || []).forEach((element) => {
            dirdConciliationReport[element.header] = element.value;
        });

        (items.reports.othersValues || []).forEach((element) => {
            othersValues[element.header] = element.value;
        });

        return { principalReport, dirdConciliationReport, othersValues };
    }

    // =================== EXPORTAÇÃO REVENUE ===================
    function dataForSheetRevenue() {
        const sheets = {};
        if (revenueReport?.data?.headersFirstTable?.length > 0 && demonstrativesRevenueRef.current) {
            const demonstrativesRevenueData = XLSX.utils.sheet_to_json(
                XLSX.utils.table_to_sheet(demonstrativesRevenueRef.current, { raw: true }),
                { header: 1, raw: true }
            );
            sheets.demonstrativesRevenueData = demonstrativesRevenueData;
        }

        if (sourceReceiptRevenueRef.current) {
            const sourceReceiptRevenueData = XLSX.utils.sheet_to_json(
                XLSX.utils.table_to_sheet(sourceReceiptRevenueRef.current, { raw: true }),
                { header: 1, raw: true }
            );
            sheets.sourceReceiptRevenueData = sourceReceiptRevenueData;
        }

        return sheets;
    }

    function dataForCsvRevenue() {
        const combinedData = [];
        if (revenueReport?.data?.headersFirstTable?.length > 0 && demonstrativesRevenueRef.current) {
            const dataTableDemonstrativesReport = XLSX.utils.sheet_to_json(
                XLSX.utils.table_to_sheet(demonstrativesRevenueRef.current, { raw: true }),
                { header: 1, raw: true }
            );
            combinedData.push(...dataTableDemonstrativesReport, []);
        }

        if (sourceReceiptRevenueRef.current) {
            const dataTableSourceReceiptReport = XLSX.utils.sheet_to_json(
                XLSX.utils.table_to_sheet(sourceReceiptRevenueRef.current, { raw: true }),
                { header: 1, raw: true }
            );
            combinedData.push(...dataTableSourceReceiptReport);
        }

        return combinedData;
    }

    function dataForJsonRevenue() {
        const dirdRevenue = {};
        const dirdRevenueDemonstratives = [];

        revenueReport?.data?.sourcesReceipts?.forEach(item => {
            dirdRevenue[item.description] = item.value;
        });

        if (revenueReport?.data?.transfers) {
            let currentRevenueDemonstrative = {};
            revenueReport.data.transfers.forEach(item => {
                for (const key of revenueReport.data.headersFirstTable) {
                    currentRevenueDemonstrative[key] = item[key];
                }
                dirdRevenueDemonstratives.push(currentRevenueDemonstrative);
                currentRevenueDemonstrative = {};
            });
        }

        return { dirdRevenueDemonstratives, dirdRevenue };
    }

    // =================== EXPORTAÇÃO FISICAL BALANCE ===================
    function dataForSheetBalance() {
        if (!financialBalanceRef.current) return {};
        const sourceFinancialBalanceData = XLSX.utils.sheet_to_json(
            XLSX.utils.table_to_sheet(financialBalanceRef.current, { raw: true }),
            { header: 1, raw: true }
        );
        return { sourceFinancialBalanceData };
    }

    function dataForCsvBalance() {
        if (!financialBalanceRef.current) return [];
        const data = XLSX.utils.sheet_to_json(
            XLSX.utils.table_to_sheet(financialBalanceRef.current, { raw: true }),
            { header: 1, raw: true }
        );
        return data;
    }

    function dataForJsonBalance() {
        const dirdFinancialBalance = {};
        fisicalBalance?.data?.sourcesFinancialBalances?.forEach(item => {
            dirdFinancialBalance[item.description] = item.value;
        });
        return { dirdFinancialBalance };
    }

    // =================== RENDER ===================
    return (
        <div>
            {(revenueReport || dirdReport || fisicalBalance) ? (
                <div className='containerDird'>
                    {/* Informações do relatório */}
                    <div className='row info-filters'>
                        <div className='col-12'>
                            <p>Projeto: <b>{projectName}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Origem dos Recursos: <b>{originResourceName}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                        </div>
                    </div>

                    {/* ====== 1. REVENUE REPORT ====== */}
                    {revenueReport && (
                        <>
                            <div className='row mb-2'>
                                <ExportButtons
                                    jsonData={dataForJsonRevenue}
                                    sheetData={dataForSheetRevenue}
                                    csvData={dataForCsvRevenue}
                                    pdfAttributes={{
                                        ids: ['demonstrativesRevenueTable', 'sourceReceiptRevenueReport']
                                    }}
                                    txtAttributes={{
                                        demonstrativesRevenueTable: { colSizes: [80] },
                                        sourceReceiptRevenueReport: { colSizes: [80] }
                                    }}
                                />
                            </div>

                            <div className='row'>
                                {revenueReport.data.headersFirstTable?.length > 0 && (
                                    <table ref={demonstrativesRevenueRef} className='table tables-report' id='demonstrativesRevenueTable'>
                                        <thead className='text-center'>
                                            <tr><th colSpan={revenueReport.data.headersFirstTable.length}>DEMONSTRATIVO DOS RECURSOS DISPONÍVEIS DO EXERCÍCIO</th></tr>
                                            <tr>
                                                {revenueReport.data.headersFirstTable.map((header, idx) => (
                                                    <th key={idx}>{header}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {revenueReport.data.transfers.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {revenueReport.data.headersFirstTable.map((col, colIndex) => (
                                                        <td key={colIndex} className={colIndex === 0 ? 'text-left' : 'text-right'}>
                                                            {row[col]}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            <div className='row'>
                                <table ref={sourceReceiptRevenueRef} className='table tables-report' id='sourceReceiptRevenueReport'>
                                    <tbody>
                                        {revenueReport.data.sourcesReceipts.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {Object.keys(row).map((key, keyIndex) => (
                                                    <td key={keyIndex} className={keyIndex === 0 ? 'text-left' : 'text-right'}>
                                                        {keyIndex === 0 ? row[key] : formatCurrency(row[key])}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                    {/* ====== 2. DIRD REPORT ====== */}
                    {dirdReport && (
                        <>
                            <div className='row mt-5 mb-2'>
                                <ExportButtons
                                    // jsonData={dataForJsonDird}
                                    sheetData={dataForSheetDird}
                                    csvData={dataForCsvDird}
                                    pdfAttributes={{
                                        ids: ['table_dird_expense', 'resume_dird_expense', 'conciliation_dird_expense']
                                    }}
                                    txtAttributes={{
                                        table_dird_expense: { colSizes: [80] },
                                        resume_dird_expense: { colSizes: [80] },
                                        conciliation_dird_expense: { colSizes: [80] }
                                    }}
                                />
                            </div>

                            <div className='row'>
                                <table ref={dirdExpenseRef} className='table table-dird tables-report' id='table_dird_expense'>
                                    <thead className='text-center'>
                                        <tr><th colSpan={6}>DEMONSTRATIVO DAS DESPESAS INCORRIDAS NO EXERCÍCIO</th></tr>
                                        <tr>
                                            {Object.keys(dirdReport.demonstrativeReport[0] || {}).map((header, index) => (
                                                <th key={index}>{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dirdReport.demonstrativeReport.map((row, rowIndex) => (
                                            <tr key={rowIndex} className={row['Categoria ou Finalidade das Despesas'] === 'TOTAL' ? 'font-weight-bold' : ''}>
                                                {Object.keys(row).map((key, colIndex) => (
                                                    <td key={colIndex} className={colIndex === 0 ? '' : 'tdValue'}>
                                                        {colIndex === 0 ? row[key] : formatCurrency(row[key])}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className='extra-div'>
                                <table ref={resumeRef} className='table table-extra tables-report mt-4' id='resume_dird_expense'>
                                    <thead>
                                        <tr><th colSpan={2} className='text-center bold-text'>RELATÓRIO DE DESPESAS COM MULTAS, JUROS, FRETES, E OUTRAS DESPESAS</th></tr>
                                        <tr><th colSpan={2} className='text-center bold-text'>CONSTATAMOS NO PERÍODO O PAGAMENTO DE DESPESAS NÃO PREVISTAS CONFORME A SEGUIR:</th></tr>
                                    </thead>
                                    <tbody>
                                        {dirdReport.othersValues
                                            .filter((item) => item.header !== 'Sub Total')
                                            .map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ width: '50rem' }}>{item.header}</td>
                                                    <td className='tdValue'>{formatCurrency(item.value)}</td>
                                                </tr>
                                            ))}
                                        <tr><td colSpan={2}></td></tr>
                                        <tr>
                                            <td>Sub Total</td>
                                            <td className='tdValue'>
                                                {formatCurrency(dirdReport.othersValues.find(item => item.header === 'Sub Total')?.value || 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table ref={conciliationRef} className='table tables-report mt-4' id='conciliation_dird_expense'>
                                    <thead>
                                        <tr><th colSpan={2} className='text-center bold-text'>CONCILIAÇÃO DIRD</th></tr>
                                    </thead>
                                    <tbody>
                                        {dirdReport.dirdConciliation.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ width: '50rem' }}>{item.header}</td>
                                                <td className='tdValue'>{formatCurrency(item.value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                    {/* ====== 3. FISICAL BALANCE ====== */}
                    {fisicalBalance && (
                        <>
                            <div className='row mt-5 mb-2'>
                                <ExportButtons
                                    jsonData={dataForJsonBalance}
                                    sheetData={dataForSheetBalance}
                                    csvData={dataForCsvBalance}
                                    pdfAttributes={{
                                        ids: ['sourceFinancialBalanceReport']
                                    }}
                                    txtAttributes={{
                                        sourceFinancialBalanceReport: { colSizes: [80] }
                                    }}
                                />
                            </div>

                            <div className='row'>
                                <table ref={financialBalanceRef} className='table tables-report' id='sourceFinancialBalanceReport'>
                                    <thead className='text-center'>
                                        <tr><th colSpan={2}>DEMONSTRATIVO DO SALDO FINANCEIRO</th></tr>
                                    </thead>
                                    <tbody>
                                        {fisicalBalance.data.sourcesFinancialBalances.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {Object.keys(row).map((key, keyIndex) => (
                                                    <td key={keyIndex} className='text-left'>
                                                        {keyIndex === 0 ? row[key] : formatCurrency(row[key])}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <div className='text-center mt-4'>
                    <p>Carregando relatórios DIRD...</p>
                </div>
            )}
        </div>
    );
};

export default Dird;
